import { Truck } from "lucide-react";

// Fulfillment is supplier-network + showroom based, so we do NOT show a
// same-day countdown we can't guarantee. Accurate, durable messaging only.
export const ShippingBanner = () => {
  return (
    <div
      className="h-9 bg-gradient-to-r from-[#E8CC6E] via-[#F0D988] to-[#E8CC6E] flex items-center justify-center px-3"
      data-testid="shipping-banner"
    >
      <p className="flex items-center gap-2 text-[11px] sm:text-xs font-semibold uppercase tracking-[0.10em] text-neutral-900 whitespace-nowrap overflow-hidden">
        <Truck size={14} strokeWidth={2} className="shrink-0" />
        <span>Free insured US shipping</span>
        <span className="hidden sm:inline text-neutral-700">· Estimated ship date shown at checkout</span>
        <span className="hidden md:inline text-neutral-700">· Katy · Copperas Cove · Killeen</span>
      </p>
    </div>
  );
};
